import { Sine, TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";
import * as Topics from "../Data/Topics";

export class ZoomOnboarding extends PIXI.Container {
    private _icon: PIXI.Sprite;
    private _overlay: PIXI.Sprite;
    private _timeline: TimelineLite | undefined;
    private _isActive: boolean;

    constructor() {
        super();
        this._isActive = false;

        this._overlay = HLF.PixiUtils.makeSprite("empty-pixel", Constants.SPRITESHEET_UI);
        this._overlay.tint = 0x000000;
        this._overlay.alpha = 0.2;
        this._overlay.interactive = true;
        this.addChild(this._overlay);

        this._icon = HLF.PixiUtils.makeSprite("onboarding-zoom", Constants.SPRITESHEET_UI);
        this.addChild(this._icon);

        this._overlay.on(HLF.Input.Events.POINTER_UP, this.onPointerUp.bind(this));

        this.hide(true);
    }

    public get isActive(): boolean {
        return this._isActive;
    }

    public onResize(pSize: PIXI.Point): void {
        this._overlay.width = pSize.x;
        this._overlay.height = pSize.y;
    }

    public show(pInstantly: boolean = false): void {
        this.killTimeline();
        this._isActive = true;
        this.visible = true;

        this._timeline = new TimelineLite();
        this._timeline.to(this, pInstantly ? 0 : 0.5, {
            alpha: 1,
            ease: Sine.easeInOut,
        });
        this._timeline.call(() => {
            this._overlay.interactive = true;
        });
    }

    public hide(pInstantly: boolean = false): void {
        this.killTimeline();
        this._isActive = false;
        this._overlay.interactive = false;

        this._timeline = new TimelineLite();
        this._timeline.to(this, pInstantly ? 0 : 0.5, {
            alpha: 0,
            ease: Sine.easeInOut,
        });
        this._timeline.call(() => {
            this.visible = false;
        });
    }

    private onPointerUp(): void {
        PubSub.publishSync(Topics.BEGIN_ZOOM, undefined);
    }

    private killTimeline(): void {
        if (this._timeline !== undefined) {
            this._timeline.kill();
            this._timeline = undefined;
        }
    }
}
